import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomerHeader from '../../../widgets/CustomerHeader/CustomerHeader';
import './UnauthedRenewalPage.css';
import { getQueryStringAsObject } from '../../../../utils/utils';
import { RaisedButton } from 'material-ui';
import { Button } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { intlText } from '../../../../utils/text-util';
import { withRouter } from 'react-router-dom';
import { TERMS_AND_CONDITIONS_URL } from '../../../../route-names';
import { SizeMe } from 'react-sizeme';

import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc =
  '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js';

const SCALE_STEP_SIZE = 0.2;
const MIN_SCALE = 1;

class UnauthedRenewalPage extends PureComponent {
  constructor(props) {
    super(props);

    const pdfBlob = new Blob([this.props.pdfData], {
      type: 'application/pdf'
    });

    this.reader = new FileReader();
    this.reader.readAsDataURL(pdfBlob);

    this.reader.onload = () => {
      this.setState({
        pdfData: this.reader.result
      });
    };

    this.state = {
      pdfData: null,
      scale: 1,
      isRenewalCompleted: false
    };

    this.onStartSigning = this.onStartSigning.bind(this);
    this.onPdfLoadSuccess = this.onPdfLoadSuccess.bind(this);
    this.onZoomIn = this.onZoomIn.bind(this);
    this.onZoomOut = this.onZoomOut.bind(this);
  }

  onPdfLoadSuccess({ numPages }) {
    this.setState({ numPages });
  }

  onZoomIn() {
    this.setState({
      scale: this.state.scale + SCALE_STEP_SIZE
    });
  }

  onZoomOut() {
    this.setState({
      scale:
        this.state.scale > MIN_SCALE + SCALE_STEP_SIZE
          ? this.state.scale - SCALE_STEP_SIZE
          : MIN_SCALE
    });
  }

  onStartSigning() {
    const queryParams = getQueryStringAsObject();

    this.props.history.push({
      pathname: TERMS_AND_CONDITIONS_URL,
      state: {
        key: queryParams.key,
        renewal: this.props.renewal,
        customer: this.props.customer,
        logo: this.props.logo
      }
    });
  }

  render() {
    return (
      <div>
        <div>
          <h1 className="customer-renewal-view-logo">
            <img src={this.props.logo} alt="C3 Link" />
          </h1>
        </div>
        <div className="main-container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15 customer-info-row-data">
              <div className="rental-service-agreement-subheader">
                {intlText(this.props, 'rental_service_agreement')}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15">
              <CustomerHeader
                customer={this.props.customer}
                renewalTermYears={this.props.renewal.renewalTermYears}
              />
            </div>
          </div>
          <div className="row">
            {this.state.isRenewalCompleted ? null : (
              <div className="start-signing">
                <span className="btn-action">
                  <Button
                    style={this.props.enabled ? {} : { display: 'none' }}
                    onClick={() => this.onStartSigning()}
                  >
                    {this.props.intl.formatMessage({ id: 'start_signing' })}
                  </Button>
                </span>
              </div>
            )}
          </div>
          <div className="row">
            {!!this.state.pdfData ? (
              <div className="start-signing">
                <RaisedButton
                  label="+"
                  primary
                  onClick={this.onZoomIn}
                  style={{ minWidth: '60px', margin: '4px' }}
                />
                <RaisedButton
                  label="-"
                  primary
                  disabled={this.state.scale === MIN_SCALE}
                  onClick={this.onZoomOut}
                  style={{ minWidth: '60px' }}
                />
                <RaisedButton
                  label="↶"
                  primary
                  disabled={this.state.scale === MIN_SCALE}
                  onClick={() => this.setState({ scale: MIN_SCALE })}
                  style={{
                    minWidth: '60px',
                    margin: '4px'
                  }}
                />
              </div>
            ) : null}
          </div>
          {!!this.state.pdfData ? (
            <div style={{ margin: 'auto' }}>
              <Document
                file={this.state.pdfData}
                onLoadSuccess={this.onPdfLoadSuccess}
              >
                {!!this.state.numPages && (
                  <SizeMe
                    className="row"
                    monitorWidth
                    refreshRate={128}
                    refreshMode={'debounce'}
                    render={({ size }) => (
                      <div style={{ overflow: 'auto', maxHeight: '600px' }}>
                        {!!this.state.numPages &&
                          Array.from(
                            new Array(this.state.numPages),
                            (el, index) => (
                              <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                renderMode="svg"
                                width={size.width}
                                scale={this.state.scale}
                              />
                            )
                          )}
                      </div>
                    )}
                  />
                )}
              </Document>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

UnauthedRenewalPage.propTypes = {
  customer: PropTypes.object.isRequired,
  renewal: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  logo: PropTypes.string.isRequired
};

export default withRouter(injectIntl(UnauthedRenewalPage));
